<!--
    @不参与审核的领导首页-项目待办时长排名-项目
-->
<template>
	<div class="leader_tasktime">
		<div class="item">
			<!-- <p class="time_title">
				<span>【{{data.field2|projectTypeMapperName}}】</span>
				<span>【{{data.field1}}】</span>
				<span>{{data.field3}}</span>
				<span class="project_default" :class="setProjectClass(data.field2)">{{data.field2|projectTypeMapperName}}</span>
			</p>
			<p class="time_handle">
				<span>处理部门：交易一科</span>
				<span>等待时长：
					<span class="time_status">{{data.durationString}}</span>
				</span>
				<el-button type="text" class="my_btn" @click="routerTo()">查看</el-button>
			</p> -->
			<div class="time_content">
				<div class="time_title">
					<div>
						<span class="project_default" :class="setProjectClass(data.field2)">{{data.field2|projectTypeMapperName}}</span>
						<span class="time_dom">{{data.field1}}</span>
					</div>
					<span class="time_main" :title="data.field3">{{data.field3}}</span>
				</div>
				<div class="time_com">
					<span>处理部门：交易一科</span>
					<span>等待时长：
						<span class="time_status">{{data.durationString}}</span>
					</span>
				</div>
			</div>
			<div class="time_btn">
				<el-button type="text" class="my_btn" @click="routerTo()">查看</el-button>
			</div>
		</div>
	</div>
</template>

<script>
import {apijwtToJsgc} from '@/server/common';
export default {
	props:{
		data:{
			type:Object,
			default:function(){
				return {};
			}
		}
	},
	data(){
		return{}
	},
	methods:{
		// 页面跳转
		apijwtToJsgc(){
			apijwtToJsgc({redUrl:this.data.field4,title:this.data.field1,field2:this.data.field2}).then((res)=>{
				const {data} = res;
				if(data.code=='1'){
					addPanel('待办详情',data.data)
				}else{
					this.$alert(data.msg);
				}
			})
		},
		routerTo(){
			this.apijwtToJsgc();
		},
		// 设置样式
		setProjectClass(value){
			let temp={
				'GC':'project_GC',
				'CG':'project_CG',
				'CQ':'project_CQ',
				'GT':'project_GT',
				'QT':'project_QT'
			}
			return temp[value];
		}
	}
}
</script>

<style lang="less" scoped>
.leader_tasktime{
	.item{
		height: 85px;
		position: relative;
		margin-bottom: 20px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		&:after{
			content: '';
			width: 100%;
			height: 1px;
			background: #ebeef5;
			position: absolute;
			bottom: 0px;
			left: 0px;
		}
		&:last-child{
			margin-bottom: 0;
		}
		.time_content{
			width: 88%;
			line-height: 35px;
			.time_title{
				display: flex;
				align-items: center;
				>div{
					width: 200px;
				}
				.time_main{
					max-width: 55%;
					display: inline-block;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
				}
				.project_default{
					display: inline-block;
					border-radius: 3px;
					padding: 7px 10px;
					font-size: 12px;
					line-height: 12px;
					margin: 0 5px 0 0;
				}
				.time_dom{
					display: inline-block;
					border-radius: 3px;
					padding: 7px 10px 7px 17px;
					font-size: 12px;
					line-height: 12px;
					background: rgba(24, 144, 255, 0.1);
					color: #1890FF;
					position: relative;
					&:before{
						content: '';
						width: 8px;
						height: 8px;
						border: 1px solid #1890FF;
						border-radius: 50%;
						position: absolute;
						left: 5px;
						top: 50%;
						transform: translate(0,-50%);
					}
				}
			}
			.time_com{
				span:first-child{
					margin-right: 20px;
				}
				.time_status{
					color: #F97077;
				}
			}
		}
		.time_btn{
			width: 12%;
			text-align: center;
		}
	}
}
</style>
